<template>
  <v-app>
    <template v-if="!loading">
      <Header />
      <v-main>
        <router-view />
      </v-main>
      <Footer />

      <div
        id="banner-popup-bottom"
        class="banner-popup-bottom"
        v-if="items.length"
      >
        <v-sheet elevation="24">
          <v-container class="py-1 relative">
            <div
              @click="close('banner-popup-bottom')"
              class="banner-popup-bottom-close"
            >
              <v-icon>fa fa-times</v-icon>
            </div>

            <a :href="content.link" target="_blank" class="banner-card d-block">
              <img
                :src="files + content.img"
                :alt="content.title"
                :title="content.title"
                loading="lazy"
                class="banner-card-image"
              />
            </a>
          </v-container>
        </v-sheet>
      </div>
    </template>
    <v-sheet
      v-else
      class="d-flex justify-center align-center"
      height="100%"
      width="100%"
      color="transparent"
    >
      <v-progress-circular
        :size="50"
        color="primary"
        indeterminate
      ></v-progress-circular>
    </v-sheet>
    <CookieBanner></CookieBanner>
  </v-app>
</template>

<script>
import Header from "@/components/shell/header/Index.vue";
import Footer from "@/components/shell/Footer.vue";
import CookieBanner from "@/components/widgets/CookieBanner.vue";

const time = 5000;

export default {
  data: () => ({
    loading: true,
    i: 0,
    interval: null,
  }),
  computed: {
    informations() {
      return this.$rest("informations").item;
    },
    name() {
      return this.informations.name || "";
    },
    items() {
      const items = this.$rest("banners").list.filter(
        ({ category: { id } }) => id === 10
      );

      return items;
    },
    content() {
      return this.items[this.i];
    },
  },
  methods: {
    updateDocumentTitle() {
      document.title = !this.name
        ? this.$route.name
        : `${this.$route.name} - ${this.name}`;
    },
    start() {
      if (this.interval) return;
      if (this.items.length > 1) {
        this.interval = setInterval(() => {
          if (this.i + 1 === this.items.length) this.i = 0;
          else this.i++;
        }, time);
      }
    },
    close(name) {
      document.getElementById(name).style.display = "none";
    },
  },
  watch: {
    $route() {
      this.updateDocumentTitle();
    },
    name() {
      this.updateDocumentTitle();
    },
    items() {
      this.start();
    },
  },
  beforeCreate() {
    this.$rest("informations")
      .get({ save: (state, data) => (state.item = data) })
      .then(() => (this.loading = false));

    this.$rest("articles-categories").get();

    this.$rest("banners").get();
  },
  created() {
    this.updateDocumentTitle();
    this.start();
  },
  components: {
    Header,
    Footer,
    CookieBanner,
  },
};
</script>

<style>
.banner-popup-bottom {
  bottom: 0;
  position: fixed;
  left: 0;
  width: 100%;
  z-index: 3000;
}

.banner-popup-bottom-close {
  align-items: center;
  background-color: #ffffff;
  border-radius: 3px 3px 0 0;
  box-shadow: 0 -2px 10px rgba(0, 0, 0, 0.4);
  cursor: pointer;
  display: flex;
  height: 20px;
  justify-content: center;
  margin-top: -20px;
  position: absolute;
  top: 0;
  right: 12px;
  width: 20px;
  z-index: 2999;
}

.banner-popup-bottom-close .v-icon {
  font-size: 14px !important;
}

@media screen and (min-width: 1200px) {
  .container {
    max-width: 1194px !important;
  }
}

.filter-white {
  filter: brightness(0) invert(1);
}
</style>
